import { hexToAscii } from 'web3-utils';

/**
 * Extract the campaignId from event, and convert from hex to ascii.
 */
export default event =>
  (event.returnValues ? hexToAscii(event.returnValues.campaignId).replace(/\0/g, '') : '');



// WEBPACK FOOTER //
// ./src/utilities/getCampaignIdFromEvent.js